// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-11-10T09:33:30Z                      #

// ##############################################################


/**
 * Vyjmenované hodnoty pro seal_Timestamp_Level.
 */
enum EnumSealTimestampLevel {
    QUALIFIED = 'QUALIFIED', 
    GUARANTEED = 'GUARANTEED', 
    NONE = 'NONE'
};
export default EnumSealTimestampLevel;

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
const params = {
    [EnumSealTimestampLevel.QUALIFIED]: {caption: ''},
    [EnumSealTimestampLevel.GUARANTEED]: {caption: ''},
    [EnumSealTimestampLevel.NONE]: {caption: ''}
};

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
export function getCaption(value) {
    return params[value].caption;
}
